/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { BillingPackage } from './BillingPackage';
import {
    BillingPackageFromJSON,
    BillingPackageFromJSONTyped,
    BillingPackageToJSON,
    BillingPackageToJSONTyped,
} from './BillingPackage';

/**
 * 
 * @export
 * @interface ListBillingPackagesResponse
 */
export interface ListBillingPackagesResponse {
    /**
     * 
     * @type {Array<BillingPackage>}
     * @memberof ListBillingPackagesResponse
     */
    data: Array<BillingPackage>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListBillingPackagesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListBillingPackagesResponse interface.
 */
export function instanceOfListBillingPackagesResponse(value: object): value is ListBillingPackagesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListBillingPackagesResponseFromJSON(json: any): ListBillingPackagesResponse {
    return ListBillingPackagesResponseFromJSONTyped(json, false);
}

export function ListBillingPackagesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBillingPackagesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BillingPackageFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListBillingPackagesResponseToJSON(json: any): ListBillingPackagesResponse {
      return ListBillingPackagesResponseToJSONTyped(json, false);
  }

  export function ListBillingPackagesResponseToJSONTyped(value?: ListBillingPackagesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BillingPackageToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

